
import groupActionTypes from '../types/groupActionTypes';
import profileActionTypes from '../types/profileActionTypes';

const initialState = {
    groups: [],
    selectedGroup: null,
    selectedProfile: null,
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null,
        action:null
    }
};

const groupReducer = (state = initialState, action) => {
    switch (action.type) {
        case groupActionTypes.START_ADD_GROUP:
        case groupActionTypes.START_DELETE_GROUP:
        case groupActionTypes.START_UPDATE_GROUP:
        case groupActionTypes.START_GET_GROUP:
        case groupActionTypes.START_ATTACH_CHARGER_GROUP:
        case profileActionTypes.START_GET_PROFILE_BY_GROUP_ID:
        case profileActionTypes.START_ACTIVATE_PROFILE:
        case profileActionTypes.START_ADD_PROFILE:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: true,
                    isSuccess: false,
                    isError: false,
                    error: null
                }
            };
        case groupActionTypes.ADD_GROUP_SUCCESS:
        case groupActionTypes.UPDATE_GROUP_SUCCESS:
        case groupActionTypes.DELETE_GROUP_SUCCESS:
        case groupActionTypes.ATTACH_CHARGER_GROUP_SUCCESS:
        case profileActionTypes.ACTIVATE_PROFILE_SUCCESS:
        case profileActionTypes.ADD_PROFILE_SUCCESS:
        case profileActionTypes.UPDATE_PROFILE_SUCCESS:
        case profileActionTypes.DELETE_PROFILE_SUCCESS:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: true,
                    isError: false,
                    action:action.action
                }
            };
        case profileActionTypes.GET_PROFILES_BY_GROUP_ID_SUCCESS:
            return updateSuccessStateWithProfiles(state, action.payload);
        case groupActionTypes.GET_GROUPS_SUCCESS:
            return {
                ...state,
                groups: action.payload,
                  stateInfo: {
                    ...state.stateInfo,
                    isLoading: false
                }
            };
        case groupActionTypes.GET_GROUPS_FAILURE:
        case profileActionTypes.GET_PROFILES_BY_GROUP_ID_FAILURE:
            return {
                ...state,
                  stateInfo: {
                    ...state.stateInfo,
                    isLoading: false
                }
            };
        case groupActionTypes.SELECT_GROUP:
            return {
                ...state,
                selectedGroup: action.payload
            };
        case profileActionTypes.SELECT_PROFILE:
            return {
                ...state,
                selectedProfile: action.payload
            };
        case groupActionTypes.UNSELECT_GROUP:
            return {
                ...state,
                selectedGroup: initialState.selectedGroup
            };
        case groupActionTypes.RESET:
            return initialState;
        case groupActionTypes.ADD_GROUP_FAILURE:
        case groupActionTypes.UPDATE_GROUP_FAILURE:
        case groupActionTypes.DELETE_GROUP_FAILURE:
        case groupActionTypes.ATTACH_CHARGER_GROUP_FAILURE:
        case profileActionTypes.ACTIVATE_PROFILE_FAILURE:
        case profileActionTypes.ADD_PROFILE_FAILURE:
        case profileActionTypes.UPDATE_PROFILE_FAILURE:
        case profileActionTypes.DELETE_PROFILE_FAILURE:

            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: false,
                    isError: true,
                    error: action.payload,
                    action: action.action
                }
            };
        case groupActionTypes.RESET_STATE_INFO:
            return {
                ...state,
                stateInfo: initialState.stateInfo
            };
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

const updateSuccessStateWithProfiles = (state, profiles) => ({
    ...state,
    groups: state.groups.map(group => {
        if (profiles.length  > 0) {
            const groupId = profiles[0].groupId
            if (group.id === groupId) {
                return {
                    ...group,
                    profiles: profiles
                };
            }
        }
        return {
            ...group,
            profiles: []
        };
    }),
    stateInfo: {
        ...state.stateInfo,
        isLoading: false
    }
});

export default groupReducer;